// extracted by mini-css-extract-plugin
module.exports = {"syllabus":"LearningModuleOverviewSyllabus_syllabus__1pmpI"};